import React, { createContext, ReactNode, useContext } from "react";

import { ISoleneService } from "../types/services/solene-sevice";

const SoleneServiceContext = createContext<ISoleneService>(
  undefined as any,
);

interface SoleneServiceProviderProps {
  service: ISoleneService;
  children: ReactNode;
}

function SoleneServiceProvider(props: SoleneServiceProviderProps) {
  const { service, children } = props;

  return (
    <SoleneServiceContext.Provider value={service}>
      {children}
    </SoleneServiceContext.Provider>
  );
}

function useSoleneService() {
  return useContext(SoleneServiceContext);
}

export { SoleneServiceProvider, useSoleneService };
